import { render, staticRenderFns } from "./Store.vue?vue&type=template&id=5883cccc&scoped=true"
import script from "./Store.vue?vue&type=script&lang=js"
export * from "./Store.vue?vue&type=script&lang=js"
import style0 from "./Store.vue?vue&type=style&index=0&id=5883cccc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5883cccc",
  null
  
)

export default component.exports